import { PlusIcon } from '@heroicons/react/24/outline'
import { ReactElement } from 'react'
import { CustomPageForm } from '../contacts/CustomPageForm'
import type { CustomPages } from 'app/types/entities'
import { showModal } from 'app/lib/modal'

export function NewList({ page, onPageCreated }: { page: CustomPages; onPageCreated: () => void }): ReactElement {
  const handleClick = () => {
    showModal(<CustomPageForm page={page} onPageCreated={onPageCreated} />, {
      title: `Create New list`,
      isFullScreen: false,
      overflowHidden: false,
      removePadding: true,
      useRadix: true,
    })
  }
  return (
    <button
      type="button"
      className="flex h-9 items-center gap-x-2 pl-1.5"
      onClick={(evt) => {
        evt.preventDefault()
        evt.stopPropagation()
        handleClick()
      }}
    >
      <div className="flex h-9 w-9 items-center justify-center">
        <PlusIcon className="aspect-square h-4 stroke-2 text-subtle" aria-hidden="true" />
      </div>
      <span className="text-label-sm text-subtle">New List</span>
    </button>
  )
}
